<template>
  <b-card>
    <b-form @submit.prevent>
      <b-row>
        <b-col md="12">
          <b-form-group label="Nome do Período" label-for="nome">
            <b-form-input
              id="nome"
              v-model="periodoVigencia.nome"
              placeholder="Ex: Exercício 2026"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Data Início" label-for="data-inicio">
            <b-form-input
              id="data-inicio"
              v-model="periodoVigencia.dataInicio"
              type="date"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Data Fim" label-for="data-fim">
            <b-form-input
              id="data-fim"
              v-model="periodoVigencia.dataFim"
              type="date"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
            <b-form-group>
                <b-form-checkbox v-model="periodoVigencia.ativo">Ativo</b-form-checkbox>
            </b-form-group>
        </b-col>

        <!-- submit and reset -->
        <b-col cols="12" class="mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="save"
          >
            {{ $t('Submit') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            @click="$emit('cancelar')"
          >
            {{ $t('Cancel') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapState } from 'vuex'
import mixinsGlobal from '@/mixins'

export default {
  components: {
    BCard, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('periodoVigenciaSettingsModule', {
      periodoVigencia: (state) => state.periodoVigencia,
    }),
  },
  methods: {
    save() {
      const action = this.periodoVigencia.id ? 'editPeriodoVigencia' : 'insertNewPeriodoVigencia'
      this.$store.dispatch(`periodoVigenciaSettingsModule/${action}`, this.periodoVigencia)
        .then(() => {
          this.showMessageSuccess('Sucesso', 'Período salvo com sucesso.')
          this.$emit('cancelar')
        })
        .catch(() => this.MensagemError('Erro', 'Falha ao salvar período.'))
    },
  },
}
</script>
